import React from 'react';
import './GradientButton.css';

export const GradientButton = ({
    title,
    onClick,
    loading = false,
    disabled = false,
    variant = 'gold',
    size = 'medium',
    icon,
    className = '',
    style = {},
}) => {
    return (
        <button
            className={`gradient-button ${variant} ${size} ${loading ? 'loading' : ''} ${className}`}
            onClick={onClick}
            disabled={disabled || loading}
            style={style}
        >
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <>
                    {icon && <span className="button-icon">{icon}</span>}
                    <span className="button-text">{title}</span>
                </>
            )}
        </button>
    );
};

export default GradientButton;
